import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute  } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var hide_show_payment_type: Function;

@Component({
  selector: 'app-my-payment-history',
  templateUrl: './my-payment-history.component.html',
  styleUrls: ['./my-payment-history.component.css']
})
export class MyPaymentHistoryComponent implements OnInit {
   
  balance:string="0";
  transactionList=[];

  paymentFormGroup;
  isSubmitPayment:boolean=false;
  paymentBTNLabel:string="Pay"; 

  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService,private route:ActivatedRoute) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.paymentFormGroup= new  FormGroup( 
      { 
      paymentType: new FormControl('topup',[Validators.required]),
      paymentWalletAmount: new FormControl("",[Validators.required]),
      paymentWalletRemark: new FormControl("",[Validators.required]),
      }
    );
    this.getMyPaymentDetail();
    hide_show_payment_type();
  }

  /** proceedPaymentRequest function used to proceed payment request */
  proceedPaymentRequest(data)
  {
     this.isSubmitPayment=true;
      if(this.paymentFormGroup.valid)
      {
          if(data.paymentType=="topup")
          {
          let detail={"ev":"tp","amount":data.paymentWalletAmount,"remark":data.paymentWalletRemark};
          let requestData=btoa(JSON.stringify(detail));
          this.router.navigate(['payment'], { queryParams: { qzwp: requestData } }); 
          }
          else if(data.paymentType=="payment")
          {

          } 
      }
  }

  /** getMyPaymentDetail function used to get my payment detail  */
  getMyPaymentDetail()
  {
    let body = { profile_id: this.sessionsService.getSession('id')};
    let result =this.httpserviceService.getMyPaymentDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.getMyPaymentDetailResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getMyPaymentDetailResponse function used to handle response */
  getMyPaymentDetailResponse(response)
  {
    console.log('getMyPaymentDetailResponse '+ response);
    if(response.status==="success")  
     {       
      if(response.balance)    
      {
        this.balance=response.balance;
      } 
      if(response.transaction_list) 
      {
        this.transactionList=response.admin_transaction_list;
      }
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

}
